/**
 * @file useConfigVersion.js
 * @description Re-render when platform_config (Admin settings) finishes loading. Pages that read prices or promo
 *   dates synchronously (getPlans, getAgencyPricing, getCachedConfig) render once with the built-in defaults if
 *   they mount before App's loadAllConfigs() resolves; this hook re-renders them with the admin values.
 * @module lib/useConfigVersion
 */
import { useEffect, useState } from "react";
import { getConfigVersion, onConfigLoaded } from "./configService";

export function useConfigVersion() {
  const [version, setVersion] = useState(getConfigVersion);
  useEffect(() => {
    const off = onConfigLoaded(setVersion);
    // the load may have finished between the first render and this effect
    if (getConfigVersion() !== version) setVersion(getConfigVersion());
    return off;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return version;
}
